module.exports = __webpack_public_path__ + "img/0Q3A2889_L_Wood_MockedUp.21cd2dca.jpg";